export default __webpack_public_path__ + "static/media/maskeko.77018a74.gif";